<template>
    <span>
        <span v-if="mostrarIdRm">{{ entrega.idRm }}</span>
        <app-status
            class="ml-1"
            :status="entrega.statusIdRmDescr"
            v-if="mostrarStatusIdRm"
        ></app-status>
        <app-status
            status="EM ATUALIZAÇÃO"
            v-if="mostrarStatusIdRmEmAtualizacao"
        ></app-status>
        <entrega-erro-comprometimento
            :entrega="entrega"
            :movimentosServicos="movimentosServicos"
        ></entrega-erro-comprometimento>
        <entrega-excluir-comprometimento
            :entrega="entrega"
            :movimentosServicos="movimentosServicos"
            @obterAtualizacao="$emit('obterAtualizacao')"
        ></entrega-excluir-comprometimento>
        <status-fin :status="entrega.statusFinIdRm"></status-fin>
    </span>
</template>

<script>
import { comprometimentoStatus } from '../ComprometimentoStatus'
import EntregaErroComprometimento from './EntregaErroComprometimento'
import EntregaExcluirComprometimento from './EntregaExcluirComprometimento'
import StatusFin from '../StatusFinIdRm'

export default {
    components: {
        EntregaErroComprometimento,
        EntregaExcluirComprometimento,
        StatusFin
    },

    props: {
        entrega: {
            type: Object,
            default: () => ({})
        },

        movimentosServicos: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    computed: {
        mostrarIdRm() {
            return (
                this.entrega.statusIdRm == comprometimentoStatus.COMPROMETIDO ||
                this.entrega.statusIdRm ==
                    comprometimentoStatus.ATUALIZAR_COMPROMETIMENTO ||
                (this.entrega.statusIdRm == comprometimentoStatus.ERRO &&
                    this.entrega.idRm)
            )
        },

        mostrarStatusIdRm() {
            return (
                this.entrega.statusIdRm == comprometimentoStatus.ERRO ||
                this.entrega.statusIdRm ==
                    comprometimentoStatus.NAO_COMPROMETIDO
            )
        },

        mostrarStatusIdRmEmAtualizacao() {
            return (
                this.entrega.statusIdRm ==
                    comprometimentoStatus.ATUALIZAR_COMPROMETIMENTO ||
                this.entrega.statusIdRm ==
                    comprometimentoStatus.EXCLUIR_COMPROMETIMENTO
            )
        }
    }
}
</script>
